import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { Provider } from "react-redux";
import WebSocketConnection from "./components/websocket-connection/websocket-connection";
import store from "./redux/store";

import "leaflet/dist/leaflet.css";
import "./index.css";
import "./mui-styles.css";

ReactDOM.render(
  <Provider store={store}>
    <WebSocketConnection />
    <App />
  </Provider>,
  document.getElementById("root")
);
